import React from 'react';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import ClosableModal from '../../../components/form/ClosableModal';

export interface VersionMismatchDialogProps {
  show?: boolean;
}

const VersionMismatchDialog: React.FC<VersionMismatchDialogProps> = ({
  show = false,
}) => {
  const intl = useIntl();

  const actions = [
    <Button
      variant="text"
      color="primary"
      key="versionMismatchDialog_action_1"
      onClick={() => window.location.reload()}
    >
      {intl.formatMessage({ id: 'refresh.page' })}
    </Button>,
  ];

  return (
    <ClosableModal
      open={show}
      actions={actions}
      title="version.mismatch"
    >
      {intl.formatMessage({ id: 'click.refresh.button' })}
    </ClosableModal>
  );
};

export default VersionMismatchDialog;
